import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';

interface SaveModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  title?: string;
  content?: ReactNode;
}

export default function SaveModal({
  visible,
  onClose,
  onConfirm,
  loading = false,
  title,
  content,
}: SaveModalProps) {
  const { t } = useTranslation();
  const { widthEditablePermission } = usePermissionStore();

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalHeader>{title || ''}</ModalHeader>
        <ModalBody>
          <Text mb="8x">{content}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={onConfirm}
            disabled={
              !widthEditablePermission(PermissionNameEnum.administrator) ||
              loading
            }
          >
            {t('common.action.label.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('reportCommon.buttons.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
